module.exports = __webpack_public_path__ + "img/peticon.1964e617.svg";